import { render, staticRenderFns } from "./CookiesConsentModal.vue?vue&type=template&id=1a32e437&scoped=true&"
import script from "./CookiesConsentModal.vue?vue&type=script&lang=js&"
export * from "./CookiesConsentModal.vue?vue&type=script&lang=js&"
import style0 from "./CookiesConsentModal.vue?vue&type=style&index=0&id=1a32e437&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32e437",
  null
  
)

export default component.exports